import { useFilters } from '@statsbomb/kitbag-global-football';
import { teamGamesBySeasonAtom, teamSelectedGamesAtom } from '@/atoms/filters/team/teamGames';
import {
  comparisonTeamGamesBySeasonAtom,
  comparisonTeamSelectedGamesAtom,
} from '@/atoms/queries/team/teamComparisonGames';
import { useGameSummary } from '@/hooks/useGameSummary';

export const useTeamGameSummary = () => {
  const [{ gameType, periodRange, startDate, endDate }] = useFilters('main');
  return useGameSummary({
    selectedGamesAtom: teamSelectedGamesAtom,
    gamesGroupedBySeasonAtom: teamGamesBySeasonAtom,
    gameType,
    periodRange,
    startDate,
    endDate,
  });
};

export const useComparisonTeamGameSummary = () => {
  const [{ gameType, periodRange, startDate, endDate }] = useFilters('comparison');
  return useGameSummary({
    selectedGamesAtom: comparisonTeamSelectedGamesAtom,
    gamesGroupedBySeasonAtom: comparisonTeamGamesBySeasonAtom,
    gameType,
    periodRange,
    startDate,
    endDate,
  });
};
